(function() {
  function updateDrawerHeaderClass() {
    const pane = document.querySelector('.drawer__menu[data-sliderule-pane]');
    const drawer = pane?.closest('header-drawer');
    if (!drawer) return;

    const paneValue = parseInt(pane.getAttribute('data-sliderule-pane'), 10);
    if (paneValue > 0) {
      drawer.classList.add('drawer--submenu-open');
    } else {
      drawer.classList.remove('drawer--submenu-open');
    }
  }

  function init() {
    const pane = document.querySelector('.drawer__menu[data-sliderule-pane]');
    if (!pane) return;

    updateDrawerHeaderClass();

    const observer = new MutationObserver(updateDrawerHeaderClass);
    observer.observe(pane, {
      attributes: true,
      attributeFilter: ['data-sliderule-pane']
    });

    document.addEventListener('theme:drawer:close', function() {
      pane.closest('header-drawer')?.classList.remove('drawer--submenu-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
